(function () {

    'use strict';

    angular.module('itxApp.home', [
        'itxApp.common',
        'itxApp.cmsPage'
    ])
    .config(XConfig);

    function XConfig($sceDelegateProvider) {
        if (inditex.iXconfVars) {
            inditex.iXconfVars.push();
        } else {
            inditex.iXconfVars = [
                'ENABLED_NUM_PHYSICAL_STORES_BY_STORE',
                'MAX_NUM_PHYSICAL_STORES'
            ];
        }

        // VIDEOS
        $sceDelegateProvider.resourceUrlWhitelist([
            // Allow same origin resource loads.
            'self',
            // Allow loading from our assets domain. **.
            'https://player.vimeo.com/**'
        ]);

    }

})();
